import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

export const AnimatedShinyArray = ({
  texts,
  renderText,
  className,
  shimmerWidth = 200,
  textDelay = 4000,
  ...props
}) => {
  const [textIndex, setTextIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(0); // Start fading out
      setTimeout(() => {
        setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setOpacity(1); // Fade in the new text
      }, 500); // Duration of the fade-out transition
    }, textDelay);

    return () => clearInterval(interval);
  }, [texts.length, textDelay]);

  return (
    <span
      style={{
        "--shiny-width": `${shimmerWidth}px`,
        opacity: opacity,
        transition: "opacity 0.5s ease-in-out", // Smooth transition for opacity
      }}
      className={cn(
        "text-gray-100/80",
        // Shine effect
        "animate-shiny-text bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shiny-width)_100%] ",
        // Shine gradient
        "bg-gradient-to-r from-transparent  via-white  via-50% to-transparent",
        className
      )}
      {...props}
    >
      {renderText ? renderText(texts[textIndex]) : texts[textIndex]}
    </span>
  );
};
